"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.sizeDecreaseCalc = exports.setFontStyles = exports.flexStyles = void 0;
exports.flexStyles = {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
};
const setFontStyles = (fontSize, fontWeight, lineHeight) => ({
    fontSize,
    fontWeight,
    lineHeight,
});
exports.setFontStyles = setFontStyles;
const sizeDecreaseCalc = (maxSize, minSize, unit) => {
    return `calc(${minSize}${unit || "px"} + (${maxSize} - ${minSize}) * ((100vw - 320px) / (1440 - 320)))`;
};
exports.sizeDecreaseCalc = sizeDecreaseCalc;
//# sourceMappingURL=index.js.map